export default "__VITE_ASSET__BHVcBH0h__"